export const sidebarPxPerRem = 14;

export const pxToRem = (valuePx: number): number => valuePx / sidebarPxPerRem;
export const remToPx = (valueRem: number): number => valueRem * sidebarPxPerRem;

export const defaultSidebarWidthRem = 20;
export const minSidebarWidthRem = 2;
export const maxSidebarWidthRem = 20;
export const sidebarPinnedMinViewportWidthRem = pxToRem(1200);

export const sidebarWidthStorageKey = 'idx.sidebar.width.rem';
export const sidebarWidthLegacyStorageKey = 'idx.sidebar.width.px';
export const sidebarPinnedStorageKey = 'idx.sidebar.is-pinned';
export const sidebarKeyboardStepRem = pxToRem(16);
export const sidebarKeyboardLargeStepRem = pxToRem(32);
export const sidebarExpandDelayMs = 130;
export const sidebarCollapseDelayMs = 320;
export const sidebarUnpinCollapseDelayMs = 100;
